module.exports = __webpack_public_path__ + "static/img/background.cc81404.png";


//////////////////
// WEBPACK FOOTER
// ./static/background.png
// module id = PMog
// module chunks = 457